import { render, staticRenderFns } from "./TelegramContactListSwitcher.vue?vue&type=template&id=881c7bf6"
import script from "./TelegramContactListSwitcher.vue?vue&type=script&lang=js"
export * from "./TelegramContactListSwitcher.vue?vue&type=script&lang=js"
import style0 from "./TelegramContactListSwitcher.vue?vue&type=style&index=0&id=881c7bf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports